import i18next  from 'i18next';

import pt from './pt';
/* import es from './es';
import en from './en';  */

i18next.addResourceBundle('pt', 'modalCookies', pt);
/* i18next.addResourceBundle('es', 'modalCookies', es);
i18next.addResourceBundle('en', 'modalCookies', en);   */